import makeRequest from '../common/helpers/makeRequest';

const isInitialized = async () => {
  return await makeRequest<{ isInitialized: boolean } | null>('/settings/init', 'GET');
};

const initialize = async (password: string, salt: string) => {
  return await makeRequest<{ isInitialized: boolean } | null>(
    '/settings/init',
    'POST',
    JSON.stringify({ password, salt })
  );
};

const fetchSalt = async () => {
  return await makeRequest<{ salt: string } | null>('/settings/salt', 'GET');
};

const login = async (password: string) => {
  return await makeRequest<{ token: string } | null>('/settings/login', 'POST', password);
};

const api = {
  isInitialized,
  initialize,
  fetchSalt,
  login,
};

export default api;
